var React = require('react');

function Bank (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11 6.857a1 1 0 011-1h.01a1 1 0 110 2H12a1 1 0 01-1-1zm.486-5.714a1 1 0 011.028 0l10 6A1 1 0 0123 8v2a1 1 0 01-1 1H2a1 1 0 01-1-1V8a1 1 0 01.486-.857l10-6zM19 12a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm-5 0a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm-4 0a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm-5 0a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm-4 9a1 1 0 011-1h20a1 1 0 110 2H2a1 1 0 01-1-1z","fill":"#3986ED"}));
}

Bank.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = Bank;

Bank.default = Bank;
